// extracted by mini-css-extract-plugin
export default {"AppAboutUs":"AppAboutUs_AppAboutUs__SdUPQ","AppAboutUs__content":"AppAboutUs_AppAboutUs__content__wr9sT"};